/* ==========================================================================
   hst-aos-reveal.js — the missing half of AOS

   THE BUG THIS EXISTS FOR
   snippets/header-oncss.liquid ships the complete AOS stylesheet, including:

       html:not(.no-js) [data-aos^=fade][data-aos^=fade]              { opacity: 0 }
       html:not(.no-js) [data-aos^=fade][data-aos^=fade].aos-animate  { opacity: 1 }

   …but the AOS *library* is not in this theme. There is no aos.js asset, no CDN
   tag, and nothing anywhere adds the `.aos-animate` class. So every element
   carrying `data-aos="fade…"` sat at opacity 0 permanently: invisible, yet still
   selectable and still read by search engines — which is exactly how it was
   reported ("the text is not visible until I select it"). 28 section types use
   the attribute, so this was site-wide, not one section.

   assets/theme.min.js also called `AOS.init(...)` unguarded, inside a
   comma-expression sequence, so the ReferenceError aborted the rest of that
   statement too. That call is now guarded; this file supplies the behaviour.

   WHY A SHIM RATHER THAN A CSS OVERRIDE
   Overriding the opacity would mean fighting a global stylesheet from every
   section that needs rescuing, and would permanently kill the animation the
   design asked for. Adding the class the stylesheet already waits for restores
   the intended reveal, touches no CSS at all, and disappears by itself the day
   the real library is installed.
   ========================================================================== */
(function () {
  'use strict';

  /* Stand down if the real library is present — it owns the class then, and two
     things writing it would double-fire the transition. */
  if (typeof window.AOS !== 'undefined' && window.AOS && window.AOS.init) return;

  /* ---- AOS-compatible stub --------------------------------------------------
     assets/theme.min.js does not only call `AOS.init()`. Immediately after it,
     on the same statement chain, it runs:

         document.querySelectorAll("img").forEach(s =>
           s.addEventListener("load", () => AOS.refresh()));

     which attaches a handler to EVERY image on the page. While `AOS.init()` was
     throwing, that line never executed. Guarding init un-blocked it, so every
     image load then threw `ReferenceError: AOS is not defined` — a bug the guard
     introduced by making previously-dead code reachable.

     Guarding each call site is whack-a-mole; there may be other AOS calls in a
     minified bundle. Publishing a minimal object the theme can talk to makes all
     of them safe at once. `refresh` re-scans, which is what the real API does,
     so behaviour is closer to correct rather than merely silent.               */
  window.AOS = window.AOS || {
    init: function () { /* the observer below already does this */ },
    refresh: function () { if (window.__hstAosScan) window.__hstAosScan(); },
    refreshHard: function () { if (window.__hstAosScan) window.__hstAosScan(); }
  };

  var SEL = '[data-aos]';
  var DONE = 'aos-animate';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    if (el && !el.classList.contains(DONE)) el.classList.add(DONE);
  }

  function revealAll(scope) {
    var els = (scope || document).querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) reveal(els[i]);
  }

  /* No IntersectionObserver, or the visitor asked for reduced motion: show
     everything at once. Content visibility is never the thing to compromise. */
  if (!('IntersectionObserver' in window) || reduced) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { revealAll(); });
    } else {
      revealAll();
    }
    document.addEventListener('shopify:section:load', function (e) { revealAll(e.target); });
    return;
  }

  /* `offset: 30` and `once: true` mirror the options theme.min.js passed to the
     real AOS, so the feel is the one the theme was built against. */
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      reveal(entries[i].target);
      io.unobserve(entries[i].target);      // once: true
    }
  }, { rootMargin: '0px 0px -30px 0px', threshold: 0 });

  function observe(scope) {
    var els = (scope || document).querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      if (!els[i].classList.contains(DONE)) io.observe(els[i]);
    }
  }

  function start() {
    observe();
    /* What AOS.refresh() reaches. Re-observing is cheap: `observe()` skips
       anything already revealed. */
    window.__hstAosScan = function () { observe(); };

    /* SAFETY NET. An element whose ancestor is display:none — a closed tab, an
       un-initialised carousel slide, a collapsed accordion — has no box, so it
       can never intersect and would stay hidden for good. Anything still
       un-revealed a moment after load is shown outright: a missed animation is
       a cosmetic loss, invisible content is not.

       Deliberately after `load` rather than on a timer from DOMContentLoaded,
       so genuinely below-the-fold content still animates on scroll instead of
       being flushed visible while images are still arriving. */
    var sweep = function () {
      window.setTimeout(function () {
        var els = document.querySelectorAll(SEL);
        for (var i = 0; i < els.length; i++) {
          var el = els[i];
          if (el.classList.contains(DONE)) continue;
          if (!el.getClientRects().length) reveal(el);   // no box => unreachable
        }
      }, 1200);
    };
    if (document.readyState === 'complete') sweep();
    else window.addEventListener('load', sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* The theme editor swaps whole sections in and out; their elements arrive
     un-observed and would never reveal. */
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
    window.setTimeout(function () {
      var els = e.target.querySelectorAll(SEL);
      for (var i = 0; i < els.length; i++) {
        if (!els[i].classList.contains(DONE) && !els[i].getClientRects().length) reveal(els[i]);
      }
    }, 400);
  });
})();
